import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import AutoSuggestPlayer from '../../shared/AutoSuggest/AutoSuggestPlayer';

const cstPlayerAccountLeagueId = "6111260368b1d71513cbaed3";

class QvneaBooksOperationModal extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			operation: this.props.modalOperation,
			seasons: [],
			seasonsTx: [],
		};

		this.handleOnBlurFloat = this.handleOnBlurFloat.bind(this);
		this.handleInputChg = this.handleInputChg.bind(this);
		this.handlePlayerChange = this.handlePlayerChange.bind(this);
		this.handlePlayerTxChange = this.handlePlayerTxChange.bind(this);
		this.handlePlayerOnBlur = this.handlePlayerOnBlur.bind(this);
		this.handlePlayerTxOnBlur = this.handlePlayerTxOnBlur.bind(this);
		this.handleCopyPlayerId = this.handleCopyPlayerId.bind(this);
		this.handleSaveOperation = this.handleSaveOperation.bind(this);
	}

	componentDidMount() {
		// console.log('QvneaBooksOperationModal: componentDidMount');
		this.initModalState(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		// console.log('QvneaBooksOperationModal: UNSAFE_componentWillReceiveProps');
		this.initModalState(nextProps);
	}

	initModalState(props) {
		var operation = props.modalOperation;
		operation.leagueIdTx = "0";
		operation.seasonIdTx = "0";

		this.loadSeasons(operation, false);
		this.setState({
			operation: operation,
			disableSubmit: false
		});
	}

	loadSeasons(operation, resetSeasonId) {
		var _this = this;
		//var operation = this.state.operation;

		Axios.get('/api/seasons/qvneaBooks/leagueId/' + operation.leagueId).then(function(responseSeasons) {
		Axios.get('/api/seasons/qvneaBooks/leagueId/' + operation.leagueIdTx).then(function(responseSeasonsTx) {

			var seasons = responseSeasons.data;
			var seasonsTx = responseSeasonsTx.data;

			if (resetSeasonId === "leagueId") {
				operation.seasonId = "0";
			}
			if (resetSeasonId === "leagueIdTx") {
				operation.seasonIdTx = "0";
			}

			_this.setState({ 
				seasons: seasons,
				seasonsTx: seasonsTx,
				operation: operation
			});
		});
		});
	}

	render() {
		//console.log('QvneaBooksOperationModal: render');
		//console.log(this.props.modalOperation);
		//console.log(this.state);

		var operation = this.state.operation;

		var addEditText = "Nouvelle opération";
		if (operation._id !== "0") {
			addEditText = "Modification";
		}

		var newTransferOperation = false;
		if ((operation._id === "0") && (operation.type === "transfert")) {
			newTransferOperation = true;
		}

		var modalSize = "sm";
		if (newTransferOperation) {
			modalSize="lg";
			addEditText += " - Transfert";
		}

		return (
    	<Modal 
  			isOpen={this.props.showModal} 
    		//toggle={this.props.handleModalCancel}		// when clicking outside the modal
				size={modalSize}
    		className={this.props.className}>

        <form className="form-horizontal" onSubmit={this.handleSaveOperation}>
    		<ModalHeader>
    			{/* toggle={this.props.handleModalCancel}> displays a small X in header */}
    			Qvnea Opérations<br/>{addEditText}
    		</ModalHeader>

    		<ModalBody>
					{this.dispForm()}
    		</ModalBody>

    		<ModalFooter>
      		<button type="button" className="btn btn-secondary btn-sm stdCommandButton2" 
      			onClick={this.props.handleModalCancel}> Annuler
      		</button>
      		<button type="submit" className="btn btn-primary btn-sm stdCommandButton2"> 
      			Enregistrer
      		</button>
    		</ModalFooter>
    		</form>
    	</Modal>
    )
	}

	dispForm() {
		var operation = this.state.operation;
    var operDate = moment(operation.date).utc().format("YYYY-MM-DD");
    var operTypeText = operation.type.charAt(0).toUpperCase() + operation.type.slice(1);

    var debitDisabled = true;
    var creditDisabled = true;

    if ((operation.type === "inscription") ||
    		(operation.type === "versement au joueur") ||
    		(operation.type === "transfert")) {
    	debitDisabled = false;
    }
    if ((operation.type === "bourse") ||
    		(operation.type === "paiement reçu") ||
    		(operation.type === "transfert")) {
    	creditDisabled = false;
    }

		var newTransferOperation = false;
		if ((operation._id === "0") && (operation.type === "transfert")) {
			newTransferOperation = true;
		}

    var dateMoneyColSize6 = "col-6";
    var operationColSize10 = "col-10";
    var leagueSeasonPlayerColSize12 = "col-12";
    if (newTransferOperation) {
    	dateMoneyColSize6 = "col-2";
    	operationColSize10 = "col-4";
    	leagueSeasonPlayerColSize12 = "col-5";
    }

    var montantTxt = "Montants";
    if (this.state.operation.type === "") {
			montantTxt += "- choisir l'opération";
    }

		return (
			<div>
        <div className="row row-margin-bottom-10">
        <div className={dateMoneyColSize6}>
					<span className="small"> Date </span> <br/>
          <input className="form-control form-control-sm" type="date" id="date" 
          	value={operDate} required
            onChange={this.handleInputChg}></input>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className={operationColSize10}>
					<span className="small"> Opération </span> <br/>
		  		<select className="form-control form-control-sm input-sm" type="text" id="type" 
		  			value={this.state.operation.type} onChange={this.handleInputChg} required>
							<option value={''} key={'otype0'}></option>
		  				{this.props.operTypes.map(this.optOperTypes)}
					</select>
				</div>
				</div>
				<hr className="hr-nomargin-top" />

				{newTransferOperation ?
	        <div className="row row-margin-bottom-10">
	        <div className={leagueSeasonPlayerColSize12}>
						<span className="small"><strong> Source (débité)</strong></span>
					</div>
	        <div className="col-1">
					</div>					
	        <div className={leagueSeasonPlayerColSize12}>
						<span className="small"><strong> Destination (crédité)</strong></span>
					</div>
					</div>
				: null}

        <div className="row row-margin-bottom-10">
        <div className={leagueSeasonPlayerColSize12}>
					<span className="small"> Joueur </span> <br/>
					<AutoSuggestPlayer playerId={operation.playerId} 
						dataChange={this.handlePlayerChange} onBlur={this.handlePlayerOnBlur}/>
				</div>

				{newTransferOperation ?
					<React.Fragment>
	        <div className="col-1">
	        	<br/>
	        	<div onClick={this.handleCopyPlayerId}><i className="fa fa-arrow-right qvneaBooksOperArrow"></i></div>
					</div>
	        <div className={leagueSeasonPlayerColSize12}>
						<span className="small"> Joueur </span> <br/>
						<AutoSuggestPlayer playerId={operation.playerIdTx} 
							dataChange={this.handlePlayerTxChange} onBlur={this.handlePlayerTxOnBlur}/>
					</div>
					</React.Fragment>
					: null }
				</div>

        <div className="row row-margin-bottom-10">
        <div className={leagueSeasonPlayerColSize12}>
					<span className="small"> Ligue / Compte </span> <br/>
					<select className="form-control form-control-sm input-sm" type="text" id="leagueId"
						value={operation.leagueId} onChange={this.handleInputChg} required>
						<option value={0} key={'opt0'}></option>
						{this.props.leagues.map(lg => (
							<option value={lg._id} key={lg._id}>{lg.name}</option>
						))}
					</select>
				</div>

				{newTransferOperation ?
					<React.Fragment>
	        <div className="col-1">
					</div>
	        <div className={leagueSeasonPlayerColSize12}>
						<span className="small"> Ligue / Compte </span> <br/>
						<select className="form-control form-control-sm input-sm" type="text" id="leagueIdTx"
							value={operation.leagueIdTx} onChange={this.handleInputChg} required>
							<option value={0} key={'opt0'}></option>
							{this.props.leagues.map(lg => (
								<option value={lg._id} key={lg._id}>{lg.name}</option>
							))}
						</select>
					</div>
					</React.Fragment>
				: null}
				</div>

        <div className="row row-margin-bottom-10">
        <div className={leagueSeasonPlayerColSize12}>
					<span className="small"> Saison (optionnel) </span> <br/>
					<select className="form-control form-control-sm input-sm" type="text" id="seasonId"
						value={operation.seasonId} onChange={this.handleInputChg} >
						<option value={0} key={'opt0'}></option>
						{this.state.seasons.map(season => (
							<option value={season._id} key={season._id}>{season.name}</option>
						))}
					</select>
				</div>

				{newTransferOperation ?
					<React.Fragment>
	        <div className="col-1">
					</div>
	        <div className={leagueSeasonPlayerColSize12}>
						<span className="small"> Saison (optionnel) </span> <br/>
						<select className="form-control form-control-sm input-sm" type="text" id="seasonIdTx"
							value={operation.seasonIdTx} onChange={this.handleInputChg} >
							<option value={0} key={'opt0'}></option>
							{this.state.seasonsTx.map(season => (
								<option value={season._id} key={season._id}>{season.name}</option>
							))}
						</select>
					</div>
					</React.Fragment>
				: null}

				</div>

				{ !newTransferOperation ?
	        <div className="row row-margin-bottom-10">
	        <div className="col-12">
						<span className="small"> {montantTxt} </span> <br/>        
					</div>

	        <div className={dateMoneyColSize6}>
						<span className="small"> Débit </span> <br/>
	          <input className="form-control form-control-sm" type="text" id="debit" 
	          	value={operation.debit} required disabled={debitDisabled}
	            onBlur={this.handleOnBlurFloat} onChange={this.handleInputChg}></input>
					</div>
	        <div className={dateMoneyColSize6}>
						<span className="small"> Crédit </span> <br/>
	          <input className="form-control form-control-sm" type="text" id="credit" 
	          	value={operation.credit} required disabled={creditDisabled}
	            onBlur={this.handleOnBlurFloat} onChange={this.handleInputChg}></input>
					</div>
					</div>
				:
					<div className="row row-margin-bottom-10">
	        <div className="col-12">
						<span className="small"> Montant à transférer </span> <br/>        
					</div>
	        <div className="col-4">
	          <input className="form-control form-control-sm" type="text" id="debit" 
	          	value={operation.debit} required disabled={debitDisabled}
	            onBlur={this.handleOnBlurFloat} onChange={this.handleInputChg}></input>
					</div>
					</div>
				}

        <div className="row row-margin-bottom-10">
        <div className={leagueSeasonPlayerColSize12}>
					<span className="small"> Notes </span> <br/>
          <input className="form-control form-control-sm" type="text" id="notes" 
          	value={operation.notes || ''}
            onChange={this.handleInputChg}></input>
				</div>
				</div>

			</div>
		)
	}

	optOperTypes(ot, otidx, opertypes) {
		return (
			<option value={ot} key={'ot.' + otidx}> {ot.charAt(0).toUpperCase() + ot.slice(1)} </option>
		)
	}

	handleOnBlurFloat(e) {
		// console.log('ON BLUR');
		var operation = this.state.operation;
		var oprop = e.target.id;
		var inputValue = e.target.value;

		// Validation on empty values
		if (inputValue === '') {
			inputValue = 0;
		}

		// numbers validation and conversion
		if(!this.isNumeric(inputValue)) {
			inputValue = 0;
		}
		
		// Set value
		operation[oprop] = inputValue;
		operation[oprop] = parseFloat(operation[oprop]);
		this.setState({ operation: operation });
	}

	handleInputChg(e) {
		var operation = this.state.operation;
		operation[e.target.id] = e.target.value;

		if ((e.target.id === "leagueId") || (e.target.id === "leagueIdTx")) {
			this.loadSeasons(operation, e.target.id);
		}

		if (e.target.id === "type") {
			operation.debit = 0;
			operation.credit = 0;
		}

		this.setState({	operation: operation });
	}

	handlePlayerChange(dataValue) {
		var operation = this.state.operation;
		operation.playerId = dataValue;
    this.setState({
    	operation: operation
    });
	}
	handlePlayerTxChange(dataValue) {
		var operation = this.state.operation;
		operation.playerIdTx = dataValue;
    this.setState({
    	operation: operation
    });
	}

	handlePlayerOnBlur(dataValue) {
		if (dataValue === '') {
			var operation = this.state.operation;
			operation.playerId = "0";
	    this.setState({operation: operation});
		}
	}
	handlePlayerTxOnBlur(dataValue) {
		if (dataValue === '') {
			var operation = this.state.operation;
			operation.playerIdTx = "0";
	    this.setState({operation: operation});
		}
	}

	handleCopyPlayerId() {
		var operation = this.state.operation;
		operation.playerIdTx = operation.playerId;
    this.setState({
    	operation: operation
    });		
	}

	handleSaveOperation(e) {
		//console.log('handleSaveOperation !');
		e.preventDefault();

		if (this.state.disableSubmit) {
			return;
		}

		var _this = this;
		var operation = this.state.operation;

    operation.debit = parseFloat(operation.debit);
    operation.credit = parseFloat(operation.credit);

		// Validation
		if (operation.leagueId === '0') {
			alert('Erreur. Vous devez spéficier une ligue.');

		}	else if (
			((operation.leagueId !== cstPlayerAccountLeagueId) && (operation.seasonId === "0")) ||
			((operation.leagueIdTx !== cstPlayerAccountLeagueId) && (operation.type === "transfert") && (operation.seasonIdTx === "0")) 
			) {
			alert("Erreur. Vous devez spéficier une saison\n(sauf pour \"QVNEA - COMPTE DU JOUEUR\")");

		}	else if (operation.playerId === '0') {
			alert('Erreur. Vous devez spéficier un joueur.');

		} else {
			_this.setState({
				disableSubmit: true
			});

			// Post operation
			Axios.post('/api/qvneaBooks/saveOperation', {
				operationObj: operation,
			})
			.then(function(response) {
				_this.props.reloadData();
				_this.props.handleModalCancel();

			})
			.catch(function(error) {
				console.log('ERROR');
				console.log(error);
				_this.props.handleModalCancel();
			});
		}
	}

	isNumeric(n) {
		// not good for negative values
		return !isNaN(parseFloat(n)) && isFinite(n);
	}

}

export default QvneaBooksOperationModal;